export default __webpack_public_path__ + "static/media/arts.474674f5.svg";